export default "__VITE_ASSET__Bkol2OzH__"